<template>
	<b-sidebar
		id="importing-contracts-sidebar"
		:visible="isImportingContractsSidebarActive"
		bg-variant="white"
		sidebar-class="sidebar-lg"
		shadow
		backdrop
		no-header
		right
		@hidden="resetForm"
		@change="(val) => $emit('update:is-importing-contracts-sidebar-active', val)"
	>
		<template #default="{ hide }">
			<!-- Header -->
			<div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
				<h5 class="mb-0">
					<strong>IMPORTAR CONTRATOS (EXCEL)</strong>
				</h5>

				<feather-icon
					class="ml-1 cursor-pointer"
					icon="XIcon"
					size="16"
					@click="hide"
				/>
			</div>

			<b-col>
				<b-button
					@click="downloadTemplate"
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="outline-success"
					size="sm"
					block
					class="mt-1"
				>
					DESCARGAR PLANTILLA
					<feather-icon
						class="cursor-pointer"
						icon="DownloadIcon"
						size="16"
						@click="hide"
					/>
				</b-button>
			</b-col>

			<!-- BODY -->
			<validation-observer
				#default="{ handleSubmit }"
				ref="refFormObserver"
			>
				<!-- Form -->
				<b-form
					class="p-2"
					@submit.prevent="handleSubmit(onSubmit)"
					@reset.prevent="resetForm"
				>
					<!-- Names -->
					<validation-provider
						#default="{ errors }"
						name="archivo"
						rules="required"
					>
						<!-- Avatar -->
						<b-form-group
							label="Archivo"
							label-for="excel-file"
						>
							<b-form-file
								id="excel-file"
								v-model="userData.file"
								:state="errors.length > 0 ? false:null"
								@change="onFileChange"
								accept=".xls, .xlsx"
								placeholder="Elija un archivo o suéltelo aquí ..."
								drop-placeholder="Suelta el archivo aquí ...."
							/>
							<small class="text-danger">{{ errors[0] }}</small>
						</b-form-group>
					</validation-provider>

					<!-- Form Actions -->
					<div class="d-flex mt-2">
						<b-button
							v-ripple.400="'rgba(255, 255, 255, 0.15)'"
							variant="primary"
							class="mr-2 mt-2"
							type="submit"
							:disabled="isLoading"
						>
							<b-spinner
								small
								v-if="isLoading"
							/>
							{{ isLoading ? 'Cargando...' : 'IMPORTAR' }}
						</b-button>
						<b-button
							v-ripple.400="'rgba(186, 191, 199, 0.15)'"
							class="mr-2 mt-2"
							type="button"
							variant="outline-secondary"
							:disabled="isLoading"
							@click="hide"
						>CANCELAR</b-button>
					</div>
				</b-form>
			</validation-observer>
		</template>
	</b-sidebar>
</template>

<script>
import useNotifications from "@notifications"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { ref, reactive } from "@vue/composition-api"
import { required } from "@validations"
import formValidation from "@core/comp-functions/forms/form-validation"
import Ripple from "vue-ripple-directive"
import vSelect from "vue-select"
import axios from "@axios"

export default {
	components: {
		// Form Validation
		ValidationProvider,
		ValidationObserver,
		vSelect
	},
	directives: {
		Ripple
	},
	model: {
		prop: "isImportingContractsSidebarActive",
		event: "update:is-importing-contracts-sidebar-active"
	},
	props: {
		isImportingContractsSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			required
		}
	},
	setup(props, { emit }) {
		const { toastNotification } = useNotifications()

		const isLoading = ref(false)
		const blankUserData = {
			file: null,
			stateFile: null
		}

		const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
		const resetuserData = () => {
			userData.value = JSON.parse(JSON.stringify(blankUserData))
		}

		const onSubmit = async () => {
			isLoading.value = true

			const formData = new FormData()
			formData.append("file", userData.value.file)

			axios
				.post("/contracts/import-template", formData, {
					headers: { "Content-Type": "multipart/form-data" }
				})
				.then((response) => {
					// Si el servidor responde con aviso no se registró nada: el panel
					// queda abierto para volver a importar el archivo corregido.
					const isWarning = response.data.state === "warning"

					if (!isWarning) {
						emit("refetch-data")
						emit("update:is-importing-contracts-sidebar-active", false)
					}

					toastNotification(response.data.message, isWarning ? "warning" : true)
				})
				.catch((error) => {
					toastNotification(error.response.data.message, false)
				})
				.finally(() => {
					isLoading.value = false
				})
		}

		const onFileChange = (e) => {
			const file = e.target.files[0]
			userData.value.file = file || null
			/* if (file) {
				userData.value.file = file
								userData.value.stateFile = Boolean(userData.value.file)
			} else {
				userData.value.file = null
				userData.value.stateFile = null
			} */
		}

		const downloadTemplate = async () => {
			try {
				const url = "/contracts/download-template"
				await axios.get(url).then(async (_) => {
					const result = await axios.get(url, {
						responseType: "blob"
					})

					const urlBlob = window.URL.createObjectURL(new Blob([result.data]))
					const link = document.createElement("a")
					link.href = urlBlob
					link.setAttribute("download", "plantilla_contratos.xlsx")
					document.body.appendChild(link)
					link.click()

					document.body.removeChild(link)
					window.URL.revokeObjectURL(urlBlob)
				})
			} catch (error) {
				toastNotification(error.response.data.message, false)
			}
		}

		const { refFormObserver, getValidationState, resetForm } =
			formValidation(resetuserData)

		return {
			userData,
			onFileChange,
			onSubmit,

			refFormObserver,
			getValidationState,
			resetForm,

			isLoading,

			downloadTemplate
		}
	}
}
</script>